export const statementStatuses = {
	0: 'Initialized',
	1: 'Paid',
	2: 'Un paid',
	3: 'Processing',
	4: 'Disputed',
	5: 'Cancelled',
	6: 'Failed',
	7: 'Scheduled',
	8: 'Processing',
	9: 'On Hold',
	10: 'Error',
	11: 'Refunded',
	12: 'Pending Finance Approval',
	13: 'Finance Approved',
	14: 'Reversed',
	15: 'Referral Auto Approved',
	16: 'Expired'
};

export default statementStatuses;

